import Parse from "helpers/parse";

export class StringToBooleanValueConverter {
    public fromView(value: any): string | null {
        return Parse.NullableString(value);
    }

    public toView(value: any): boolean | null {
        return Parse.NullableBoolean(value);
    }
}
